import { ContentType } from "utils/constant";

// ==================== 公用模块 ====================
/** 文件下载 */
export const fileDownloadUrl = `/api/file/download`;
export const fileUploadUrl = `/api/file/upload`;

// ==================== 用户模块 ====================
// 用户登录
export const login = {
  url: '/api/web/auth/login',
  method: 'POST',
  headers: {
    "Content-Type": ContentType.json,
  },
};
// 用户登录
export const tokenInvalid = {
  url: '/api/web/auth/hashToken',
  method: 'GET',
};
// 发送验证码
export const sendSMSCode = {
  url: '/api/app-gateway/auth/send/smsVerifyCode',
  method: 'GET',
};
// 获取用户信息
export const userInfo = {
  url: '/api/web/auth/info',
  method: 'GET',
};

// ==================== 立即预约 ====================
export const booking = {
  url: '/api/user/concat/appointment',
  method: 'POST',
  headers: {
    "Content-Type": ContentType.json,
  },
};

// ==================== 消息中心 ====================
// 消息列表
export const messageList = {
  url: '/api/message/list/page',
  method: 'POST',
  headers: {
    "Content-Type": ContentType.json,
  },
};
// 一条消息已读
export const readAMessage = {
  url: '/api/message/consumer/msg',
  method: 'GET',
};
// 全部已读
export const readAllMessage = {
  url: '/api/message/consumer/user',
  method: 'GET',
};
// 消息统计
export const messageCount = {
  url: '/api/message/count',
  method: 'GET',
};
// 删除消息
export const deleteMessage = {
  url: '/api/message/delete',
  method: 'GET',
};

// ==================== 开票管理 ====================
// 开票中、已开票列表
export const invoiceList = {
  url: '/api/bill/list/page',
  method: 'POST',
  headers: {
    "Content-Type": ContentType.json,
  },
};
/** 申请开票列表分页 */
export const orderInvoiceList = {
  url: '/api/order/bill/list/page',
  method: 'POST',
  headers: {
    "Content-Type": "application/json",
  },
};
// 申请开票
export const applyInvoice = {
  url: '/api/bill/save',
  method: 'POST',
  headers: {
    "Content-Type": "application/json",
  },
};

// ==================== 商品列表 ====================
// 大数据商品列表
export const goodsList = {
  url: '/api/goods/data/list',
  method: 'GET',
};

// 外综服平台、国际物流平台商品列表
export const softwareList = {
  url: '/api/goods/software/list',
  method: 'GET',
};

/** 软件商品权益列表 */
export const apiGoodsRightsTemp = {
  url: '/api/goods/rights/list',
  method: 'GET',
}

/** 软件商品功能table */
export const apiGoodsTableTemp = {
  url: '/api/goods/software/function/template/table/list',
  method: 'GET',
}

// 软件商品下单
export const addCart = {
  url: '/api/order/software/order',
  method: 'GET',
}

// 大数据商品下单
export const bigDataAddCart = {
  url: '/api/order/data/order',
  method: 'GET',
}

// 购物车列表
export const cartList = {
  url: '/api/order/car/list',
  method: 'GET',
}

// 购物车列表详情(商品权益)
export const goodsRight = {
  url: '/api/goods/software/snapshot/right/list',
  method: 'GET',
}

// 微信扫码支付
export const scanPay = {
  url: '/api/order/pay/scene',
  method: 'POST',
  headers: {
    "Content-Type": ContentType.json,
  },
}

// 微信支付状态查询
export const queryScanRecord = {
  url: '/api/payment/record/info',
  method: 'GET',
}

// 文件上传-银行卡付款凭证上传
export const paymentVoucherUpload = {
  url: `${fileUploadUrl}/payment`,
  method: 'POST',
  headers: {
    "Content-Type": ContentType.form,
  },
}

// 银行卡转账支付（提交）
export const bankPay = {
  url: '/api/order/pay/bank',
  method: 'POST',
  headers: {
    "Content-Type": ContentType.json,
  },
}

/** 查询公司基本信息 */
export const apiEnterpriseInfo = {
  url: '/api/enterprise/info',
  method: 'GET',
}

/** 大数据订单列表分页 */
export const apiDataOrderList = {
  url: '/api/order/data/web/list/page',
  method: 'POST',
  headers:{
    'Content-Type': ContentType.json,
  }
}

/** 全景报告（基础版） */
export const apiDomesticCreditCompanyBase = {
  url: '/api/report/domesticCreditCompanyBase',
  method: 'GET',
}

/** 全景报告（尊享版） */
export const apiDomesticCreditCompanyEnjoy = {
  url: '/api/report/domesticCreditCompanyEnjoy',
  method: 'GET',
}

/** 获取评分 */
export const apiReportScore = {
  url: '/api/report/score',
  method: 'GET',
};

/** 获取历史评分 */
export const apiHistoryReportScore = {
  url: '/api/report/score/history',
  method: 'GET',
};

// ==================== 订单中心 ====================
/** 订单列表分页 */
export const apiOrderList = {
  url: '/api/order/list/page',
  method: 'POST',
  headers: {
    "Content-Type": "application/json",
  },
};

/** 软件订单列表分页 */
export const apiSoftwareOrderList = {
  url: '/api/order/software/web/list/page',
  method: 'POST',
  headers: {
    "Content-Type": "application/json",
  },
};

/** 报告查询历史列表 */
export const apiHistoryReportList = {
  url: '/api/data/history/web/list/page',
  method: 'POST',
  headers: {
    "Content-Type": "application/json",
  },
};
